<script>
    import { onMount, onDestroy } from 'svelte';
    import {Link, navigate} from "svelte-routing";
    import {findInstagramUser, getUserInfo, createTemporaryAnalyze} from "../lib/ApiRequests.svelte";
    import {_} from '../lib/i18n';

    export let analyzes = [];
    export let params = {};

    export let totalAnalyzes = 0;

    export let maxAllowedAccountsToAdd = 3;

    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let identity;
    $: identity = (params ? params.identity : null);

    let results = [];
    let selectedAccount = {};
    let showResults = false;
    let isLoading = false;
    let enableAddButton = false;
    let searchQuery = '';

    let analyzeCreationInProgress = false;
    let addButtonLabel = $_('addAccount.addButtonLabel');
    let errorText = '';

    onMount(() => {
        //window.scrollTo(0, 0);

        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: $_('addAccount.pageTitle'),
                    pageTitleTag: $_('addAccount.pageTitleTag'),
                });
            }
        } catch (err) {
            console.error(err);
        }


        if (analyzes.length === 0 && localStorage.getItem('lastAccountInfo')) {
            const landingAccount = JSON.parse(localStorage.getItem('lastAccountInfo'));
            searchQuery = landingAccount.username;
            selectAccount(landingAccount);
            createAnalyze();
        }

        if (identity.spy_balance === 0) {
            try {
                if (identity.spy_has_full_payments) {
                    identity.changeKeyValue('showAnalyzesLimitWarning', true);
                    //navigate(`${path}/dashboard`);
                } else if (analyzes.length > 0) {
                    navigate(`${path}/dashboard/subscription`);
                }

            } catch (err) {
                console.error(err);
            }
        } else {
            try {
                console.log(identity.spy_has_full_payments, analyzes.length >= maxAllowedAccountsToAdd)
                if (identity.spy_has_full_payments && analyzes.length >= maxAllowedAccountsToAdd) {
                    identity.changeKeyValue('showAnalyzesLimitWarning', true);
                    navigate(`${path}/dashboard`);
                } else if (!identity.spy_has_full_payments && analyzes.length > 0) {
                    navigate(`${path}/dashboard/subscription`);
                }

            } catch (err) {
                console.error(err);
            }
        }
    });

    onDestroy(() => {

    });

    async function makeSearchRequest(query) {
        const response = await findInstagramUser(query);
        if (response.status === 'ok' && response.data.length > 0) {
            results = response.data;
            showResults = true;
        }
        isLoading = false;
    }

    let searchInputTimeout = null;
    function search() {
        results = [];
        showResults = false;
        //enableAddButton = true;
        if (searchQuery.length < 3) return;

        if (searchInputTimeout) {
            clearTimeout(searchInputTimeout);
        }

        searchInputTimeout = setTimeout(() => {
            isLoading = true;
            makeSearchRequest(searchQuery);
        }, 1000);
    }

    function onImageError(event) {
        event.target.src = '/spy20-lk/icons/avatar-empty.svg';
    }

    function selectAccount(accountInfo) {
        searchQuery = accountInfo.username;
        selectedAccount = accountInfo;
        showResults = false;
        isLoading = false;
        enableAddButton = true;
    }

    let createAnalyzeInterval;
    let analyzeCreated = false;
    let newAnalyzeInfo = {};
    let selectedAccountInfo = {};
    async function createAnalyze() {
        for (let i = 0; i < analyzes.length; i++) {
            const analyze = analyzes[i];
            console.log(analyze);
            if (analyze.account && analyze.account.username === selectedAccount.username) {

                console.log('Analyze already exists');
                return ;
            }
        }


        analyzeCreationInProgress = true;
        analyzeCreated = false;
        errorText = '';
        newAnalyzeInfo = {};
        selectedAccountInfo = {};

        addButtonLabel = $_('addAccount.searchingLabel');

        const infoResponse = await getUserInfo(selectedAccount.username);

        if (infoResponse.status === 'error') {
            errorText = response.data.username;
            return onCreateAnalyzeFailed();
        }

        createTemporaryAnalyze(
            selectedAccount.id,
            selectedAccount.username,
            selectedAccount.name,
            selectedAccount.photo,
            infoResponse.data.media_count,
            infoResponse.data.follows_count,
            infoResponse.data.followers_count
        )
            .then((response) => {
                if (response.status === 'ok') {
                    analyzeCreated = true;
                    newAnalyzeInfo = response.data;
                    selectedAccountInfo = response.data;
                }
            });


        const statusList = [
            //$_('addAccount.searchingLabel'),
            $_('addAccount.titleAndDescription'),
            $_('addAccount.likes'),
            $_('addAccount.comments'),
            $_('addAccount.posts'),
            $_('addAccount.postsMarks'),
            $_('addAccount.followsAndFollowers'),
        ];

        let statusBtnTextIndex = 0; // начинаем с нулевого элемента массива

        createAnalyzeInterval = setInterval(() => {
            addButtonLabel = statusList[statusBtnTextIndex];
            statusBtnTextIndex++;
            if (statusBtnTextIndex > statusList.length) {
                try {
                    clearInterval(createAnalyzeInterval);
                } catch (err) {}
                onAnalyzeCreated();
            }
        }, 2000);
    }

    function resetButtonState() {
        analyzeCreationInProgress = false;
        addButtonLabel = $_('addAccount.addButtonLabel');
    }

    function onCreateAnalyzeFailed() {
        resetButtonState();

        setTimeout(() => {
            errorText = '';
        }, 3000);
    }
    function onAnalyzeCreated() {
        resetButtonState();

        if (analyzeCreated) {
            try {
                if (params.addAnalyze instanceof Function) {
                    params.addAnalyze(
                        true,
                        selectedAccount.username,
                        selectedAccount.id,
                        selectedAccount.username,
                        selectedAccount.name,
                        selectedAccount.photo,
                        selectedAccountInfo.victim_medias,
                        selectedAccountInfo.victim_followers,
                        selectedAccountInfo.victim_follows
                    );
                }
                window.location.href = (`${path}/dashboard/analyze/${selectedAccount.username}?clear-cache=y`);
            } catch (err) {console.error(err)}
        }
    }

</script>


<div class="canvas__col">
    <section class="add-account-block tail">
        <h2 class="add-account-block__title tail__title">{$_('addAccount.blockTitle')}</h2>
        <p class="add-account-block__text tail__text">{$_('addAccount.blockDescription')}</p>
        <div class="add-account-block__form-wrapper form" id="add-account-form">
            <div class="custom-select add-account-block__select">
                <div class="custom-select__field-wrapper">
                    <input type="text"
                           class={`general-input custom-select__input add-account-block__input ${errorText ? 'error' : ''}`}
                           placeholder={$_('addAccount.inputPlaceholder')}
                           bind:value={searchQuery}
                           on:input={search}
                    />
                    {#if isLoading}
                        <span class="custom-select__loader block"></span>
                    {/if}
                </div>
                {#if showResults}
                <div class="custom-select__list-wrapper block">
                    <ul class="custom-select__list custom-select__list_users">
                        {#each results as item}
                            <li class="custom-select__list-item" on:click={selectAccount(item)}>
                                <div class="custom-select__list-item-img-wrapper">
                                    <img src={item.photo}
                                         alt={item.username}
                                         class="custom-select__list-item-img"
                                         on:error={onImageError}
                                    />
                                </div>
                                <p class="custom-select__list-item-name">{item.username}</p>
                            </li>
                        {/each}
                    </ul>
                </div>
                {/if}
            </div>

            <button class={`button button_icon-text button_shadow add-account-block__btn ${analyzeCreationInProgress ? 'add-account-block__btn_loading' : ''} ${errorText ? 'error' : ''}`} disabled={!enableAddButton || analyzeCreationInProgress} on:click={createAnalyze}>
                {#if analyzeCreationInProgress}
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.6665 16.0001C2.6665 23.3641 8.63584 29.3334 15.9998 29.3334C23.3638 29.3334 29.3332 23.3641 29.3332 16.0001C29.3332 8.63608 23.3638 2.66675 15.9998 2.66675" stroke="#595866" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                {:else}
                    {#if !errorText}
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 20.5V19.5C4 16.7386 6.23858 14.5 9 14.5H12.75M17.5355 14.4645V18M17.5355 18V21.5355M17.5355 18H21.0711M17.5355 18H14M15 7.5C15 9.70914 13.2091 11.5 11 11.5C8.79086 11.5 7 9.70914 7 7.5C7 5.29086 8.79086 3.5 11 3.5C13.2091 3.5 15 5.29086 15 7.5Z" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    {/if}
                {/if}
                {#if errorText}
                    {$_('addAccount.error')}
                {:else}
                    {addButtonLabel}
                {/if}
            </button>
            {#if errorText}
                <p class="add-account-block__form-error tail__error">{errorText}</p>
            {/if}
        </div>
    </section>
</div>

<style>
    .button.error {
        background-color: transparent;
        box-shadow: none;
    }
    .block {
        display: block;
    }
    img.custom-select__list-item-img {
        max-width: 40px;
    }

    .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
    }
</style>